import React, { createContext, useContext, useEffect, useState } from 'react';
import { toAbsoluteUrl } from '../../../helpers';

const themeModeLSKey = 'kt_theme_mode_value';
const themeMenuModeLSKey = 'kt_theme_mode_menu';

const themeModeSwitchHelper = () => {
    const imageUrl = '/media/patterns/header-bg.jpg';
    document.body.style.backgroundImage = `url("${toAbsoluteUrl(imageUrl)}")`;
};

const getThemeModeFromLocalStorage = (lsKey) => {
    if (!localStorage) {
        return 'light';
    }
    const data = localStorage.getItem(lsKey);
    return data === 'light' ? data : 'light';
};

const defaultThemeMode = {
    mode: 'light',
    menuMode: 'light',
    updateMode: () => {},
    updateMenuMode: () => {},
};

const ThemeModeContext = createContext(defaultThemeMode);
const useThemeMode = () => useContext(ThemeModeContext);

const ThemeModeProvider = ({ children }) => {
    const [mode, setMode] = useState('light');
    const [menuMode, setMenuMode] = useState('light');

    const updateMode = (_mode) => {
        setMode('light');
        if (localStorage) {
            localStorage.setItem(themeModeLSKey, 'light');
        }
        document.documentElement.setAttribute('data-theme', 'light');
    };

    const updateMenuMode = (_menuMode) => {
        setMenuMode('light');
        if (localStorage) {
            localStorage.setItem(themeMenuModeLSKey, 'light');
        }
    };

    useEffect(() => {
        updateMode();
        updateMenuMode();
    }, []);

    return (
        <ThemeModeContext.Provider value={{ mode, menuMode, updateMode, updateMenuMode }}>
            {children}
        </ThemeModeContext.Provider>
    );
};

export { ThemeModeProvider, useThemeMode, themeModeSwitchHelper };